// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","spin":"Spinner_spin__DSOqJ","fullscreen":"Spinner_fullscreen__RD1ep"};